<template>
	<div class="content my-0 py-1">
		<div class="container-fluid">
			<div class="row">
				<div class="col-12  mt-2 py-0">
					<h4 class="m-0 p-0 text-secondary d-inline">Keluhan </h4>
					<button class="float-right btn btn-primary shadow mt-2" v-on:click="formComplaint=!formComplaint">
						Tambah Keluhan baru
					</button>
				</div>
				<transition name="fade">
					<div class="col-12  my-2 py-0" v-if="formComplaint">
						<div class="row p-3 mx-2 bg-white shadow">
							<div class="col-12 mb-3">
								<h4 class="my-0 py-0">Form Keluhan Baru</h4>
								<hr>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">Keluhan <span style="color:red;">*</span></label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="newComplaint.complaint_name"/>
							</div>
							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start" v-if="newSaved">
									<div class="alert alert-success" role="alert">
										Berhasil Menyimpan Keluhan Baru.
									</div>
								</div>
							</div>

							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start" v-if="errorNew">
									<div class="alert alert-danger" role="alert">
										<div class="my-0">
											<p class="d-block mt-1">{{ createErrorMessage }}</p>
										</div>
										<div v-for="err in errorList" v-bind:key="err" class="my-0">
											<p v-for="note in err" v-bind:key="note" class="d-block mt-1 w-100">
												{{ note }}</p>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 mt-3">
								<div class="d-flex align-items-center justify-content-start" v-if="savingNew">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
								</div>
								<button class="btn btn-primary float-right" type="button" v-on:click="saveNewComplaint">
									Simpan
								</button>
							</div>
						</div>
					</div>
				</transition>


				<div class="col-12  my-2 py-0">
					<datatable :currentIdx="currentPage" :datas="complaints" :structure="tableStructure"
					           :init="loadData"
					           :next-url="nextUrl" :prev-url="prevUrl" @change-page="(isNext)=>{changePage(isNext)}"
					           use-seeker seeker-url="/api/master/seeker/troubleshoot-complaint"
					           @refetch="(row)=>{rowLimit=row;getComplaints()}"
					           @searching="(val)=>!val.status?getComplaints():complaints=val.data">
						<template #customcell={obj,index}>
							<td v-if="isMobile" class="py-3">
								<ul style="list-style:none;width:100%;padding:0" class="rounded shadow bg-white p-2">
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Keluhan:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.complaint_name }}</b>
										</div>
										<hr class="my-1">
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 mt-2 pt-0">
											<b-button v-b-modal.modal-edit-complaint class="btn btn-info mr-2"
											          v-on:click="selectedComplaint=index;dataEdit=Object.assign({},obj)">
												<b-icon icon="pencil-square"></b-icon>
											</b-button>
											<b-button v-b-modal.modal-delete
											          v-on:click="deleteId=obj.id;itemToDelete=obj"
											          class="btn btn-danger">
												<b-icon icon="trash"></b-icon>
											</b-button>

										</div>
									</li>
								</ul>
							</td>
							<td v-if="!isMobile">{{ ((currentPage - 1) * perPage) + index + 1 }}</td>
							<td v-if="!isMobile">{{ obj.complaint_name }}</td>
							<td v-if="!isMobile">
								<b-button title="Edit" v-b-modal.modal-edit-complaint class="btn btn-info mr-2"
								          v-on:click="selectedComplaint=index;dataEdit=Object.assign({},obj)">
									<b-icon icon="pencil-square"></b-icon>
								</b-button>
								<b-button title="Delete" v-b-modal.modal-delete
								          v-on:click="deleteId=obj.id;itemToDelete=obj" class="btn btn-danger">
									<b-icon icon="trash"></b-icon>
								</b-button>
							</td>
						</template>
					</datatable>
				</div>

				<b-modal no-close-on-esc content-class="m-0" id="modal-edit-complaint" title="Edit Lokasi" scrollable
				         no-close-on-backdrop size="lg" @hide="editModalClose">
					<b-container fluid v-if="!loadData&&complaints.length>0">
						<b-row class="mt-3 pt-1" v-if="complaints[selectedComplaint]!=undefined">
							<b-col cols="12" class="my-1">
							</b-col>
							<b-col cols="12" md="6" lg="4">
								<label class="d-block">Keluhan </label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="complaints[selectedComplaint].complaint_name"/>
							</b-col>

							<b-col cols="12" class="my-3 text-right" v-if="updateState">
								<div class="d-flex align-items-center justify-content-start">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
								</div>
							</b-col>
							<div class="col-12 mt-3" v-if="updateSaved">
								<div class="w-100 align-items-center justify-content-start">
									<div class="alert alert-success" role="alert">
										Berhasil update data keluhan.
									</div>
								</div>
							</div>
							<div class="col-12 mt-3" v-if="errorSaved">
								<div class="w-100 align-items-center justify-content-start">
									<div class="alert alert-danger" role="alert">
										Gagal update data keluhan.
									</div>
								</div>
							</div>
							<b-col cols="12" class="my-3 text-right">
								<button class="btn btn-info" v-on:click="updateData">Simpan</button>
							</b-col>
						</b-row>
					</b-container>
					<template #modal-footer>
						<div class="w-100 text-right m-0 p-0">
							<hr>
							<b-button class="btn btn-secondary mr-2"
							          @click="(!updateState)?$bvModal.hide('modal-edit-complaint'):''">Tutup
							</b-button>
							<!-- <button class="btn btn-info" v-on:click="updateClientData">submit</button> -->
						</div>
					</template>
				</b-modal>
				<modal-delete url="/api/master/troubleshoot-complaint/" @read="()=>{console.log('modal ready')}"
				              @result="deleteResult" :targetid="deleteId">
					Yakin mau menghapus data dengan detail berikut :<br>
					<ul>
						<li>Lokasi: {{ itemToDelete.complaint_name }}</li>
					</ul>
				</modal-delete>


			</div>
		</div>
	</div>
</template>
<script>
//   import ChartCard from 'src/components/Cards/ChartCard.vue'
//   import StatsCard from 'src/components/Cards/StatsCard.vue'
//   import LTable from 'src/components/Table.vue'
import * as axios from "axios";
import Datatable from "../../components/Datatable.vue";
import SmartSelect from "../../components/SmartSelect.vue";
import ModalDelete from "../../components/ModalDelete.vue";

export default {
	components: {
		//   LTable,
		//   ChartCard,
		//   StatsCard
		"datatable": Datatable,
		"smart-select": SmartSelect,
		"modal-delete": ModalDelete
	},
	data() {
		return {
			currentPage: 1,
			perPage: null,
			rowLimit: 10,
			nextUrl: null,
			prevUrl: null,
			isMobile: false,
			//step 1 edit
			dataEdit: null,
			deleteId: 0,
			createErrorMessage: "Gagal Menyimpan Keluhan  Baru.",
			errorMessages: [],
			itemToDelete: {},
			complaints: [],
			searchValue: "",
			loadData: true,
			savingNew: false,
			errorNew: false,
			errorList: [],
			errorSaved: false,
			existingClientResult: [],
			newSaved: false,
			updateState: false,
			updateSaved: false,
			updateUserState: false,
			selectedComplaint: 0,
			selectedTab: 0,
			updateClientCol: 6,
			newComplaint: {
				complaint_name: ""
			},
			formComplaint: false,
			tableStructure: [
				//label: nama heading, key: nama object property
				{label: "No", key: null},
				{label: "Keluhan", key: null},
				{label: "Tindakan", key: null}
			]
		};
	},
	created() {
		console.clear();
		this.$reActivateAccess(this); /*SETTIMEOUT LOGOUT OTOMATIS, (this,true) UTK MELIHAT DETIK DI BROWSHER*/
		console.log("hardware type page");
		this.getComplaints();
		this.isMobile = this.$isMobile;
		window.addEventListener("resize", () => {
			console.log("screen update");
			this.isMobile = screen.width < 768;
		});
		// var newData = [];
		// for(var x=0;x<100;x++){
		//     newData.push({id:x,name:'nama_'+x,username:'nama'+x,role:'user'});
		// }
		// console.log(newData);
		// this.complaints = newData;
	},
	methods: {
		changePage(isNext) {
			var url = (isNext ? this.nextUrl : this.prevUrl);
			let params = (new URL(url)).searchParams;
			const myParams = params.get("page");
			this.currentPage = parseInt(myParams);
			var newUrl = this.$baseUrl + "/api/master/troubleshoot-complaint?limit=" + this.rowLimit + "&page=" + myParams;
			this.getComplaints(newUrl);
		},
		deleteResult(deleted) {
			console.log(deleted);
			if (deleted) {
				this.getComplaints();
			}
		},
		getComplaints(url = (this.$baseUrl + "/api/master/troubleshoot-complaint?limit=" + this.rowLimit)) {
			this.loadData = true;
			axios.get(url, {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				console.log(result);
				this.prevUrl = result.data.prev_page_url;
				this.nextUrl = result.data.next_page_url;
				this.currentPage = result.data.current_page;
				this.perPage = parseInt(result.data.per_page);
				this.complaints = result.data.data;
				this.loadData = false;
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err);
				this.loadData = false;
			});
		},
		saveNewComplaint() {
			this.savingNew = true;
			this.errorNew = false;
			console.log(this.newComplaint);
			if (this.newComplaint.complaint_name) {
				axios.post(
					this.$baseUrl + "/api/master/troubleshoot-complaint",
					{
						complaint_name: this.newComplaint.complaint_name
					},
					{
						"headers":
							{
								"Authorization": "Bearer " + localStorage.getItem("accessToken")
							}
					}
				).then((result) => {
					console.log(result);
					if (result.status == 200) {
						this.newComplaint.complaint_name = "",
							this.savingNew = false;
						this.newSaved = true;
						this.getComplaints();
					}
					setTimeout(() => {
						this.newSaved = false;
						this.formComplaint = false;
					}, 1000);

				}).catch((err) => {
					//check if token fail
					if (err.response && err.response.status == 401) {
						localStorage.removeItem("accessToken");
						this.$router.push("/login");
					}
					console.log(err.response);
					this.errorList = [];
					this.errorList = Object.values(err.response.data.errors);
					console.log(this.errorList);
					this.errorNew = true;
					this.savingNew = false;
				});
			} else {
				//pakai ini ary
				this.errorNew = true;
				this.savingNew = false;
				this.errorList = [];
				if (this.newComplaint.complaint_name == "") {
					this.errorList.push(["- Mohon isi Keluhan "]);
				}
				console.log(this.errorList);
			}
		},
		newUsernameChange() {
			this.newComplaint.password = this.newComplaint.username.toUpperCase();
		},
		deleteItem(item) {
			console.log("button delete untuk keluhan id: " + item.id);
		},
		updateUserRoleValue(newValue) {
			this.newComplaint.role = newValue;
		},
		setNewClientId(newId) {
			this.newComplaint.clientId = newId;
			console.log(this.newComplaint.clientId);
		},

		updateData() {
			console.log("updating data");
			this.updateState = true;
			axios.put(
				this.$baseUrl + "/api/master/troubleshoot-complaint/" + this.complaints[this.selectedComplaint].id,
				{
					complaint_name: this.complaints[this.selectedComplaint].complaint_name

				},
				{
					"headers": {
						"Authorization": "Bearer " + localStorage.getItem("accessToken")
					}
				}
			).then((result) => {
				if (result.status == 200) {
					this.updateState = false;
					this.updateSaved = true;
					//step 4 edit
					this.dataEdit = this.complaints[this.selectedComplaint];
					setTimeout(() => {
						this.updateSaved = false;
						this.$bvModal.hide("modal-edit-complaint");
					}, 1000);
					console.log("yaya berhasil");
				}
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				this.updateState = false;
				this.errorSaved = true;
				setTimeout(() => {
					this.errorSaved = false;
				}, 1000);
				console.log(err.response);
			});
		},
		editModalClose(mdl) {
			//step 2 edit
			this.$set(this.complaints, this.selectedComplaint, this.dataEdit);
			//step 3 edit
			this.dataEdit = Object.assign({}, null);
			if (this.updateState) {
				console.log("updating");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-edit-complaint");
			}
		},
		deleteModalClose(mdl) {
			if (this.deleteLocationState) {
				console.log("deleting");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-delete-location");
			}
		},

		deleteClientData() {
			console.log("deleting data");
			this.deleteLocationState = true;
			axios.delete(
				this.$baseUrl + "/api/master/troubleshoot-complaint/" + this.complaints[this.selectedToDelete].id,
				{
					"headers": {
						"Authorization": "Bearer " + localStorage.getItem("accessToken")
					}
				}
			).then((result) => {
				if (result.status == 200) {
					this.deleteLocationState = false;
					this.locationDeleted = true;
					this.complaints.splice(this.selectedToDelete, 1);

					setTimeout(() => {
						this.$bvModal.hide("modal-delete-location");
						this.locationDeleted = false;
					}, 1000);
					console.log("yaya berhasil");
				}
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				this.deleteLocationState = false;
				this.failDeleteUser = true;
				setTimeout(() => {
					this.failDeleteUser = false;
				}, 1000);
				console.log(err);
			});
		}
	}
};
</script>
<style scoped>
.btn {
	padding: 2px 6px;
}

::v-deep .modal-content {
	margin: -3.25rem auto;
}
</style>
